import React, { useState, useContext } from "react";
import { UserContext } from "../pages/userContext";
import "../pages/AboutUs.css";

export const AboutUs = () => {
  const { userDetails } = useContext(UserContext);

  return (
    <div className="Ctm-detail">
      <div className="ctmprofile">
        <h1>CVIFIR Logged in User Detail</h1>
      </div>
      {userDetails ? (
        <div className="Userdetail">
          <p>
            <strong>Position Name:</strong> {userDetails.position_name}
          </p>
          <p>
            <strong>Organization Name:</strong> {userDetails.organization_name}
          </p>
          <p>
            <strong>User Login:</strong> {userDetails.user_login_s}
          </p>
          <p>
            <strong>Region:</strong> {userDetails.region}
          </p>
          <p>
            <strong>Area:</strong> {userDetails.area}
          </p>
          <p>
            <strong>State:</strong> {userDetails.user_state}
          </p>
          {/* <p>
            <strong>Email ID:</strong> {userDetails.email_id}
          </p> */}
          <p>
            <strong>Email ID:</strong>
            {userDetails.email_id.split(";").map((email, index) => (
              <span key={index}>
                {email.trim()}
                <br />
              </span>
            ))}
          </p>
        </div>
      ) : (
        <p>No user details available. Please log in.</p>
      )}
    </div>
  );
};
//uncomment it for the edit profile bar below the my profile
// export const OurAim = () => {
//     return (
//         <div className="home">
//             {/* <h1>CV IFIR edit profile</h1> */}
//         </div>
//     );
// };

export const OurVision = () => {
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Form submission logic here
      console.log("Form submitted successfully!");
    } else {
      console.log("Form submission failed due to validation errors.");
    }
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.old_password.trim()) {
      errors.old_password = "Old password is required";
    } else if (data.old_password.length < 8) {
      errors.old_password = "Old password must be at least 8 characters long";
    }

    if (!data.new_password) {
      errors.new_password = "New password is required";
    } else if (data.new_password.length < 8) {
      errors.new_password = "New password must be at least 8 characters long";
    } else if (data.new_password === data.old_password) {
      errors.new_password = "New password should not be same as old password";
    }

    if (data.confirm_new_password !== data.new_password) {
      if (data.confirm_new_password !== data.new_password) {
        errors.confirm_new_password = "New password do not match";
      }
    } else if (data.confirm_new_password === data.old_password) {
      errors.confirm_new_password =
        "New confirm password should not be same as old password";
    }

    return errors;
  };

  return (
    <div className="form-container">
      <h2 className="form-title">Change Your Password</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label className="form-label">Old Password:</label>
          <input
            className="form-input"
            type="password"
            name="old_password"
            value={formData.old_password}
            onChange={handleChange}
          />
          {errors.old_password && (
            <span className="error-message">{errors.old_password}</span>
          )}
        </div>
        <div>
          <label className="form-label">New Password:</label>
          <input
            className="form-input"
            type="password"
            name="new_password"
            value={formData.new_password}
            onChange={handleChange}
          />
          {errors.new_password && (
            <span className="error-message">{errors.new_password}</span>
          )}
        </div>
        <div>
          <label className="form-label">New Password Confirmation:</label>
          <input
            className="form-input"
            type="password"
            name="confirm_new_password"
            value={formData.confirm_new_password}
            onChange={handleChange}
          />
          {errors.confirm_new_password && (
            <span className="error-message">{errors.confirm_new_password}</span>
          )}
        </div>
        <button className="submit-button" type="submit">
          Update Password
        </button>
      </form>
    </div>
  );
};
